import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
    emptyBox: {
        margin: "0 auto",
        textAlign: "center",
        fontSize: "18px",
        color: "rgba(0, 0, 0, 0.87)",
    },
    emptyContentBox: {
        display: "flex",
        alignItems: "center",
        "&.MuiBox-root": {
            backgroundColor: "unset",
            minHeight: "58vh",
            borderBottom: "none",
        },
    },
    root: {
        display: "flex",
        minHeight: "calc(100vh - 40px)",
        marginTop: -20,
        fontFamily: "Roboto",
        "& .boxColor": {
            textAlign: "center",
        },
    },
    ivRoot: {
        display: "flex",
        minHeight: "100vh",
        marginTop: -1,
        fontFamily: "Roboto",
        "& .boxColor": {
            textAlign: "center",
        },
    },
    header: {
        marginTop: 30,
        marginBottom: 10,
        fontSize: 34,
    },
    detailText: {
        color: "#707070",
        fontSize: 22,
    },
    createButton: {
        padding: "3px 24px",
        fontSize: 15,
        marginTop: 15,
        marginBottom: 36,
    },
    ivuserScreen: {
        color: "#fff !important",
        backgroundColor: "#000",
        "& .MuiTypography-alignCenter": {
            color: "#fff !important",
        },
        "& .boxColor": {
            width: "80%",
            height: "70vh",
            paddingTop: "17vh",
            backgroundImage: "linear-gradient(to top, #2a2c37 -15%, #15191f 70%);",
            marginTop: 70,
            borderRadius: 8,
        },
        "& .detail-text": {
            fontSize: 19,
            paddingLeft: 16,
            paddingRight: 16,
            fontWeight: 300,
        },
    },
    ivScreenDiv: {
        objectFit: "none",
        zIndex: 1,
        justifyContent: "center",
        display: "flex",
        backgroundColor: "#000",
        "& img, & svg": {
            position: "absolute",
            top: "40px",
        },
    },
}));
